import React from 'react'

import Chequerboard from '../chequerboard'

import './chequerboardGroup.css'

const ChequerboardGroup = ({ data }) => {
  const config = {
    titleColor: data.config && data.config.titleColor ? data.config.titleColor : 'white',
    textColor: data.config && data.config.textColor ? data.config.textColor : 'white',
    bgColor: data.config && data.config.bgColor ? data.config.bgColor : 'black',
  }

  return (
    <section className={`chequerboardGroup bg-${config.bgColor} text-${config.textColor}`}>
      {data.title && <h2 className={`group-title text-${config.titleColor}`}>{data.title}</h2>}
      {data.items.map((item, index) => (
        <Chequerboard data={item} key={`item-${index}`}></Chequerboard>
      ))}
    </section>
  )
}

export default ChequerboardGroup
